import React from 'react';
import ovenLogo from '../assets/ovenessence.png'
const Locations = () => {
  return (
    <div className='mx-2' id='locations'>
        <h1 className='section-header mt-5'>Now available at</h1>
        <div className='location-card'>
          <img src={ovenLogo} alt='Oven Essence logo' />
          <h2 className='mb-0'>Oven Essence</h2>
          <p>20 N Washington St, North Attleborough, MA</p>
          </div>
    </div>
  );
};

export default Locations;
